import { useEffect, useState } from "react";
import { FaInstagram, FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { LuFacebook, LuMessageCircle } from "react-icons/lu";
import { MdOutlineEmail } from "react-icons/md";
import { getFirestore, collection, doc, query, where, orderBy, onSnapshot, getDoc } from "firebase/firestore";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";

export default function Footer() {
    const [revenda, setRevenda] = useState({});

    const navLinks = [
        { href: "/", label: "Home" },
        { href: "/estoque", label: "Estoque" },
        { href: "/financiamento", label: "Financiamento" },
        { href: "/venda", label: "Venda" },
        { href: "/contato", label: "Contato" },
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
        const firestore = getFirestore(app);

        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        getDoc(revendaRef).then((docSnap) => {
            if (docSnap.exists()) {
                setRevenda(docSnap.data());
            }
        });

        const q = query(
            collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
            where("veremovido", "==", 0),
            where("vevendido", "==", 0),
            orderBy("updated_at", "desc")
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
                const document = doc.data();
                document.id = doc.id;
                if (document["veexibir_site"] !== false) {
                    items.push(document);
                }
            });
        });

        return () => unsubscribe();
    }, []);

        return (
            <footer className="relative bg-white text-black overflow-hidden">
                {/* Linha decorativa */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[60%] h-px bg-gradient-to-r from-transparent via-red-600/60 to-transparent" />

                <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-12">

                    {/* Branding */}
                    <div>
                        <img
                            src="/logo-white.png"
                            alt="AutoVendas - Kátia Moraes"
                            className="w-48 mb-4"
                        />

                        <p className="text-sm text-black/70 max-w-sm mb-6">
                           Sua loja de confiança para adquirir veículos 0 de qualidade com um atendimento excepcional e preços competitivos!
                        </p>

                        <div className="flex gap-4 text-xl">
                            <a className="hover:text-red-500 transition" href={revenda.facebook_link}>
                                <LuFacebook />
                            </a>
                            <a className="hover:text-red-500 transition" href={revenda.instagram_link}>
                                <FaInstagram />
                            </a>
                            <a
                                className="hover:text-red-500 transition"
                                href={`https://api.whatsapp.com/send?phone=55${retiraMascara(revenda.petelefone2, "link")}`}
                            >
                                <LuMessageCircle />
                            </a>
                        </div>
                    </div>

                    {/* Navegação */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6 relative">
                            Links rápidos
                            <span className="block w-8 h-[2px] bg-red-600 mt-2" />
                        </h3>

                        <ul className="space-y-3 text-sm text-black/70">
                            {navLinks.map(link => (
                                <li key={link.href}>
                                    <a
                                        href={link.href}
                                        className="hover:text-black transition"
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contato */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6 relative">
                            Contato
                            <span className="block w-8 h-[2px] bg-red-600 mt-2" />
                        </h3>

                        <div className="space-y-4 text-sm text-black/70">
                            <div className="flex gap-3">
                                <FaLocationDot className="text-red-600 mt-1" />
                                <p>
                                    {revenda.peendereco_fiscal}, {revenda.peendereco_fiscal_numero} – {revenda.pebairro_fiscal}, {revenda.pecidade} - {revenda.peuf}
                                </p>
                            </div>

                            <div className="flex gap-3 items-center">
                                <FaPhoneAlt className="text-red-600" />
                                <span>{retiraMascara(revenda.petelefone1)}</span>
                            </div>

                            <div className="flex gap-3 items-center">
                                <LuMessageCircle className="text-red-600" />
                                <span>{retiraMascara(revenda.petelefone2)}</span>
                            </div>

                            <div className="flex gap-3 items-center">
                                <MdOutlineEmail className="text-red-600" />
                                <span>{revenda.peemail}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="border-t border-white/10 py-4 text-center text-xs text-black/60">
                    © 2026 AutoVendas - Kátia Moraes. Todos os direitos reservados.
                    <a
                        className="ml-2 hover:text-black transition text-red-600 font-semibold"
                        href="https://intermedioveiculos.com.br/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Intermédio Veículos Marketing Digital
                    </a>
                </div>
            </footer>
        );

}
